import { USER } from "../../constants";
import axios from "@helpers/axios/private.axios";
import { syncSavedTimezone } from "@helpers/timezone";

export const getUserData = () => async (dispatch) => {
  try {
    dispatch({ type: USER.USER_REQUEST });

    const response = await axios.get("/users/me");
    const data = response?.data?.data || {};
    const user = data?.user || null;
    const is_banned = Boolean(user?.is_banned);
    const isFirstLogin = Boolean(data?.is_first_login);

    if (!is_banned) {
      syncSavedTimezone(user);
      dispatch({
        type: USER.USER_RESPONSE,
        payload: {
          user,
          isFirstLogin,
        },
      });
    }

    return {
      is_banned,
      isFirstLogin,
    };
  } catch (error) {
    console.error(error);

    return {
      is_banned: false,
      isFirstLogin: false,
    };
  }
};